import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useCreatePinCodeMutation } from "@/services/api/entities/pinCode";
import { enterPinHasErrorSelector, selectAuthStatus, useAuth } from "@/services/auth";
import { useAppSelector } from "@/services/store";
import { appRouterPaths } from "@/services/navigation";

export const useCheckStatus = () => {
  const navigate = useNavigate();
  const authStatus = useAppSelector(selectAuthStatus);
  const enterPinHasError = useAppSelector(enterPinHasErrorSelector);

  const { accessPinHandler } = useAuth();

  const [createPinCode, { isLoading: pinFetching }] = useCreatePinCodeMutation();

  const handleCreatePin = useCallback(
    (pin: string) => {
      createPinCode({ pin })
        .unwrap()
        .then(() => {
          accessPinHandler(pin);
        })
        .catch(() => {
          navigate(appRouterPaths.logIn);
        });
    },
    [createPinCode, navigate],
  );

  const handlePinAccess = useCallback(
    (pin: string) => {
      accessPinHandler(pin);
    },
    [accessPinHandler],
  );

  return {
    state: {
      authStatus,
      pinFetching,
      enterPinHasError,
    },
    methods: {
      handleCreatePin,
      handlePinAccess,
    },
  };
};
